import { IPaginatedApiResponse } from '@/Interfaces/ApiResponse/PaginatedApiResponse.interface';
import { IClientPayload, IClientResponseItem } from '@/Interfaces/Client.interface';
import { CLIENTS_ENDPOINT, CLIENTS_LIST_ENDPOINT } from '@/constants/endpoints';
import { SearchClientsPayload } from '@/types/clients.types';
import axios from 'axios';

export const fetchClientsList = async (
  params: SearchClientsPayload,
): Promise<IPaginatedApiResponse<IClientResponseItem[]>> => {
  const res = await axios.get(CLIENTS_LIST_ENDPOINT, { params });
  return res.data;
};

export const createClient = async (payload: IClientPayload): Promise<IClientResponseItem> => {
  const res = await axios.post(CLIENTS_ENDPOINT, payload);
  return res.data;
};

export const updateClient = async (id: number, payload: IClientPayload): Promise<IClientResponseItem> => {
  const res = await axios.put(`${CLIENTS_ENDPOINT}/${id}`, payload);
  return res.data;
};
